module.exports = __webpack_public_path__ + "img/小狐狸.b1d63311.png";